import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ArticleDetail from './pages/ArticleDetail';
import LegalPage from './pages/LegalPage';
import ServicesPage from './pages/ServicesPage';
import Contact from './pages/Contact';
import Careers from './pages/Careers';

// Generic placeholder for simpler pages
const SimplePage = ({ title }) => (
  <div className="pt-40 pb-24 bg-white min-h-screen">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <h1 className="text-4xl font-serif mb-6">{title}</h1>
      <p className="text-slate-600 leading-relaxed italic">Content for {title} is currently being updated for the Q4 global report. Please check back shortly.</p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-50 font-sans text-slate-800 flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/insights/:id" element={<ArticleDetail />} />
            <Route path="/legal/:type" element={<LegalPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/leadership" element={<SimplePage title="Leadership" />} />
            <Route path="/locations" element={<SimplePage title="Global Locations" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;